import { render } from "./CartRemindersUnsubscribe.vue?vue&type=template&id=bcbcecb8&lang=pug"
import script from "./CartRemindersUnsubscribe.vue?vue&type=script&lang=js"
export * from "./CartRemindersUnsubscribe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__